var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FrsModuleRoot',{attrs:{"module":_vm.module,"module-path":['fieldRecordSystem', 'nutrientRequirements'],"translation-namespaces":['nutrientRequirements'],"setup":_vm.loadPrerequisiteData}},[_c('NutrientRequirements')],1)}
var staticRenderFns = []

export { render, staticRenderFns }